import { render } from "./LeaveLogo.vue?vue&type=template&id=362a45fe"
import script from "./LeaveLogo.vue?vue&type=script&lang=js"
export * from "./LeaveLogo.vue?vue&type=script&lang=js"

import "./LeaveLogo.vue?vue&type=style&index=0&id=362a45fe&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__